module.exports = __webpack_public_path__ + "block-3-1x-68cd15ddb74f328b4cb9686b80afed9d.webp";